
import Event = createjs.Event;

export class AvatarCreationEvent extends Event {
    public static AVATAR_CREATION_SUCCESSFUL: string = "avatarcreationsuccessfull";
    public static AVATAR_NAME_SUGGESTIONS: string = "avatarnamesuggestions";
    public static AVATAR_NAME_SELECTED: string = "avatarnameselected";

    public params: any[] = null;

    constructor(type: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.params = params;
    }
}
